import React from 'react';
import StockLocationNotification from './StockLocation/stockLocationNotification';
import BinStatusNotification from './BinStatus/binStatusNotification';
import BinNotification from './Bin/binNotification';
import ProductMasterDataNotification from './ProductMasterData/productMasterDataNotification';
import TaskNotification from './Task/taskNotification';
import CommentNotification from './Comment/commentNotification';
import ContactNotification from './Contact/contactNotification';
import AlertNotification from './Alerts/alertNotification';
import EntityNotification from './EntityNotification';
import ContainerNotification from './Container/containerNotification';
import AssetNotification from './Asset/assetNotification';
import AssetTransactionNotification from './AssetTransaction/assetTransactionNotification';
import LotNotification from './Lot/lotNotification';
import TriggerNotification from './Trigger/triggerNotification';
import CompanyConnectionNotification from './CompanyConneciton/companyConnectionNotification';
import IntegrationSettingsNotification from './IntegrationSettings/integrationSettingsNotification';
import KitNotification from './Kit/kitNotification';

interface NotificationHandlerProps {}

export default function NotificationHandler({}: NotificationHandlerProps) {
  return (
    <>
      <EntityNotification />

      <BinStatusNotification />
      <ContactNotification />
      <ProductMasterDataNotification />
      <StockLocationNotification />
      <BinNotification />
      <TaskNotification />
      <CommentNotification />
      <AlertNotification />
      <ContainerNotification />
      <LotNotification />
      <AssetNotification />
      <AssetTransactionNotification />
      <LotNotification />
      <TriggerNotification />
      <IntegrationSettingsNotification />
      <CompanyConnectionNotification />
      <KitNotification />
    </>
  );
}
